window.addEventListener('load', () => {
  const header = document.querySelector('.header');
  const video = document.querySelector('.accueil__hero__video > video');

  if (header) {
    const removeHeaderBtmClass = () => {
      header.classList.remove('header--btm');
    };

    if (video) {
      video.addEventListener('ended', removeHeaderBtmClass);
    }
  }

  // Récupération de tous les éléments de collectionsItems
  const collectionsItems = document.querySelectorAll('#collections-items > li');

  // Récupération de tous les éléments de collectionsImages
  const collectionsImages = document.querySelectorAll(
    '#collections-images > img'
  );

  // Récupération de l'élément #collections-title
  const collectionsTitle = document.querySelector('#collections-title');

  // Fonction pour mettre à jour le titre de la collection
  function updateTitle(title) {
    collectionsTitle.innerText = title;
  }

  // Fonction pour ajouter une classe à l'élément correspondant dans collectionsImages
  function highlightImage(slug) {
    collectionsImages.forEach((image) => {
      if (image.getAttribute('data-slug') === slug) {
        image.setAttribute('data-visible', 'true');
      } else {
        image.setAttribute('data-visible', 'false');
      }
    });
  }

  // Ajout d'une écoute d'événement pour chaque élément de collectionsItems
  collectionsItems.forEach((item) => {
    item.addEventListener('mouseenter', (event) => {
      const slug = event.target.getAttribute('data-slug');
      const title = event.target.getAttribute('data-title');
      highlightImage(slug);
      updateTitle(title);
    });
  });

  collectionsItems[0].dispatchEvent(new Event('mouseenter')); // Déclencher l'événement "mouseenter" sur le premier item
});
